export const isCheckinFlightGuard = (flight) => {
    return !('segments' in flight);
};
export const isCheckinSegmentGuard = (segment) => {
    return 'checkinInfo' in segment;
};
